import React, { createContext, useContext, useState } from "react";

import Cart from "../components/Reusable/Cart";
import CustomModal from "../components/Reusable/CustomModal";
import InfoLogin from "../components/Reusable/InfoLogin";
import LoginForm from "../components/Reusable/LoginForm";
import DeactivateAccount from "../components/Reusable/DeactivateAccount";
import SubscribeModal from "../components/Reusable/SubscribeModal";

const ModalContext = createContext();
export const useGlobalModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(null); // 'login' | 'cart' | 'info' | 'deactivate' | 'subscribe'
  const [modalProps, setModalProps] = useState({}); // npr. { message: "…" }

  const openModal = (type, props = {}) => {
    setModalType(type);
    setModalProps(props);
    setShowModal(true);
  };

  // samo promeni sadržaj bez zatvaranja, čuva onSuccess iz prethodnog modala
  const switchModal = (type, props = {}) => {
    setModalType(type);
    setModalProps((prev) => ({
      ...props,
      onSuccess: props.onSuccess || prev.onSuccess,
    }));
  };

  const closeModal = (type = "") => {
    setShowModal(false);
    setModalType(null);
    setModalProps({});

    if (type == "login") {
      const url = new URL(window.location.href);

      if (url.searchParams.has("login")) {
        url.searchParams.delete("login");
        window.history.replaceState(
          {},
          document.title,
          `${url.pathname}${url.search}${url.hash}`
        );
      }
    }
  };

  const openLogin = (props) => openModal("login", props);
  const openInfo = (props) => openModal("info", props);
  const openCart = (props) => openModal("cart", props);
  const openDeactivate = (props) => openModal("deactivate", props);
  const openSubscribe = (props) => openModal("subscribe", props);

  const value = {
    openModal,
    switchModal,
    closeModal,
    openLogin,
    openInfo,
    openCart,
    openDeactivate,
    openSubscribe,
  };

  return (
    <ModalContext.Provider value={value}>
      {children}

      {showModal && (
        <CustomModal
          show={showModal}
          hideModal={closeModal}
          classValue={"login-modal-main-container"}
          centered
          size={"lg"}
        >
          {modalType === "info" && (
            <InfoLogin
              hideModal={closeModal}
              showLogin={() => switchModal("login")}
              {...modalProps} // npr. message
            />
          )}

          {modalType === "login" && (
            <LoginForm
              hideModal={() => closeModal("login")}
              {...modalProps}
            />
          )}

          {modalType === "cart" && (
            <Cart hideModal={closeModal} {...modalProps} />
          )}

          {modalType === "deactivate" && (
            <DeactivateAccount hideModal={closeModal} {...modalProps} />
          )}

          {modalType === "subscribe" && (
            <SubscribeModal hideModal={closeModal} {...modalProps} />
          )}
        </CustomModal>
      )}
    </ModalContext.Provider>
  );
};
